import { createCustomValueByType } from "PFCore/services/admin/custom_values";
import { MutationOptions } from "PFTypes/request_options";

import { MutationFnParams, useCustomValueCreate } from "./use_custom_value_create";

export const useCreateCustomValueByType = ({ ...props }: MutationOptions<MutationFnParams> = {}) =>
  useCustomValueCreate({ ...props }, createCustomValueByType);
